// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videos-card-container .title h3 {
  text-transform: none;
  text-transform: initial;
}
.videos-card-container .title-container {
  display: flex;
  align-items: center;
}
.videos-card-container .title-container .QuestionMarkTooltip {
  margin-left: 8px;
  display: flex;
  align-items: center;
}
.videos-card-container .content {
  background: transparent;
}
.videos-card-container .card-content {
  display: flex;
  margin-bottom: 16px;
}
.videos-card-container .selected-video {
  width: 640px;
}
.videos-card-container .cactus {
  width: 120px;
  height: 85%;
  display: block;
  margin: 0 auto;
}
.videos-card-container > .Loading {
  flex: 1 1;
  height: 362px;
}
.videos-card-container .videos-grid-wrapper {
  padding-bottom: 0;
}
.videos-card-container .see-more {
  margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/VideosCard/index.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;EAAA,uBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAEI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAAN;AAIE;EACE,uBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAOE;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AALJ;AAQE;EACE,SAAA;EACA,aAAA;AANJ;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,gBAAA;AARJ","sourcesContent":[".videos-card-container {\n  .title h3 {\n    text-transform: initial;\n  }\n\n  .title-container {\n    display: flex;\n    align-items: center;\n    .QuestionMarkTooltip {\n      margin-left: 8px;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .content {\n    background: transparent;\n  }\n\n  .card-content {\n    display: flex;\n    margin-bottom: 16px;\n  }\n\n  .selected-video {\n    width: 640px;\n  }\n\n  .cactus {\n    width: 120px;\n    height: 85%;\n    display: block;\n    margin: 0 auto;\n  }\n\n  & > .Loading {\n    flex: 1;\n    height: 362px;\n  }\n\n  .videos-grid-wrapper {\n    padding-bottom: 0;\n  }\n\n  .see-more {\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
